module.exports = __webpack_public_path__ + "img/Disconnect.a53828be.png";